<div class="row">
  <div class="col-lg-12 grid-margin">
    <div class="card">
      <div class="card-body upper-header">
        <div class="d-flex bd-highlight mb-3">
          <div class="p-2 bd-highlight">
            <div class="form-group">
              <label>From Date</label>
              <input class="form-control border-primary" [max]="to_date" [owlDateTime]="dt" placeholder="Date" name="from_date"
                [(ngModel)]="from_date" readonly>
              <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
              <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
            </div>
          </div>
          <div class="p-2 bd-highlight">
            <div class="form-group">
              <label>To Date</label>
              <input class="form-control border-primary" [min]="from_date" [max]="maxDate" [owlDateTime]="dt1" placeholder="Date" name="to_date"
                [(ngModel)]="to_date" readonly>
              <span [owlDateTimeTrigger]="dt1" class="date-ico"><i class="fa fa-calendar"></i></span>
              <owl-date-time #dt1 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
            </div>
          </div>
          <div class="p-2 bd-highlight">
            <div class="form-group">
              <button type="button" style="margin-top: 30px;" class="btn btn-inverse-primary btn-fw top-btn-head" (click)="getList($event)">Load</button>
            </div>
          </div>
        </div>
        <h4 class="card-title">
          <div class="d-flex bd-highlight">
            <div class="p-2 flex-grow-1 bd-highlight">Bhaktniwas Donations</div>
            <div class="p-2 bd-highlight" *ngIf="permissionsService.checkPermission('export_donation_requests')">
              <button type="btn" class="btn btn-primary btn-fw" (click)="exportData()">Export</button>
            </div>
          </div>
        </h4>
        <div class="table-responsive" *ngIf="donationRequests && donationRequests.data && donationRequests.data.length">
          <table class="table">
            <thead>
            <tr>
              <th>S.No</th>
              <th>Date</th>
              <th>Full Name</th>
              <!-- <th>Father Name</th> -->
              <th>Mobile No.</th>
              <th>Payment Type</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let data of donationRequests?.data; let i = index">
              <td>
                <span *ngIf="page == 1">{{i+1}}</span>
                <span *ngIf="page > 1">{{((page - 1 )*perPage) + (i+1)}}</span>
              </td>
              <td>{{data?.created_at}}</td>
              <td>{{data?.full_name}}</td>
              <!-- <td>{{data?.father_name}}</td> -->
              <td>{{data?.mobile_no}}</td>
              <td>{{data?.payment_process_completed ? 'Paid' : 'Pending'}}</td>
              <td>{{data?.amount}}</td>
              <td><a *ngIf="data?.payment_process_completed" href="{{data.actual_receipt_url}}" target="_blank"><i class="fa fa-print ml-4" aria-hidden="true"
                   ></i></a></td>
              <!-- <td>
                <button *ngIf="data?.status === 'Pending' && permissionsService.checkPermission('approve_donation_request')"
                        class="btn btn-success btn-sm" (click)="changeStatus(data.id, 'Approved')">Approve</button>
                <button *ngIf="data?.status === 'Pending' && permissionsService.checkPermission('reject_donation_request')"
                        class="btn btn-danger btn-sm ml-1" (click)="changeStatus(data.id, 'Rejected')">Reject</button>
              </td> -->
            </tr>
            </tbody>
          </table>
        </div>
        <div class="p-12" *ngIf="donationRequests && donationRequests.data && !donationRequests.data.length">
          <span class="ng-star-inserted no_data">No Data found.</span>
        </div>
        <ngb-pagination *ngIf="donationRequests && donationRequests.data && donationRequests.data.length" [collectionSize]="totalCount" [pageSize]="perPage"
        [(page)]="page" (pageChange)="onPageChange($event)" [maxSize]="3"
        class="pull-right justify-content-end page-mt-10"
        aria-label="Default pagination"></ngb-pagination>
      </div>
    </div>
  </div>
</div>